import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { AuthService } from './../../../../../../../services/auth.service';
import { MemberService } from './../../../../../../../rest/api/member.service';

@Component({
  selector: 'app-delete-title-modal',
  templateUrl: './delete-title-modal.component.html',
  styleUrls: ['./delete-title-modal.component.scss']
})
export class DeleteTitleModalComponent implements OnInit, OnChanges {

  @Input() selectedMedia;
  @Output() deleteModalCloseEmit = new EventEmitter();
  isSubmitted = false;
  accessToken: any;
  deleteError;
  deleteSuccess;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedMedia && changes.selectedMedia.currentValue) {
      this.resetErrorValues();
    }
    // if (changes.deleteSuccess && changes.deleteSuccess.currentValue) {
    //   this.isSubmitted = false;
    //   setTimeout(() => {
    //     this.modalCloseEmit.emit(true);
    //   }, 2000);
    // }
  }

  deleteSingleMedia(selectedMedia) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteError = undefined;
    this.memberService.deleteSingleMedia({
      Authorization: this.accessToken,
      id: selectedMedia.uuid
    }).subscribe((response: any) => {
      this.deleteSuccess = 'Media has been successfully deleted.';
      setTimeout(() => {
        this.deleteModalCloseEmit.emit(selectedMedia);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteError = err.error.error;
      } else {
        this.deleteError = 'There was error while deleting media.';
      }
    });
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }

  closeModal() {
    this.deleteModalCloseEmit.emit(undefined);
  }

}
